import { AddressView } from "@gearbox-protocol/deploy-tools-ui";
import type { FC } from "react";

import { useFaucet } from "./FaucetProvider";

const FaucetAddressCard: FC = () => {
  const { address } = useFaucet();

  return (
    <div className="flex flex-row items-center justify-between gap-2 rounded-lg border border-border p-4">
      <span className="text-sm text-muted-foreground">Faucet contract</span>
      <AddressView address={address} hideEtherscan />
    </div>
  );
};

export default FaucetAddressCard;
